export const en = {
  // Home Page strings
  title: "Book of Heaven",
  Home_Description: "Explore the 36 volumes of the Book of Heaven written by the Servant of God Luisa Piccarreta, where the gift of living in the Divine Will is revealed.",
  description: "Explore the 36 volumes of the Book of Heaven written by the Servant of God Luisa Piccarreta, where the gift of living in the Divine Will is revealed.",
  register: "Register",
  registerMobile: "Register",
  logout: "Logout",
  userLogin: "Login",
  adminAccess: "Administrator access",
  evangelioButton: "Gospel of the Day",
  evangelioButtonDescription: "Read today's gospel reading",
  temasButton: "Explore Topics",
  temasDescriptionAuthenticated: "Discover organized topics from the Book of Heaven",
  temasDescriptionUnauthenticated: "Log in to discover organized topics from the Book of Heaven",
  loading: "Loading volumes...",
  errorLoading: "Error loading data",
  sessionExpired: "Session expired. Redirecting to login...",
  available: "Available",
  unavailable: "Not available",
  detailedContent: "✨ Detailed content",
  requiresAccount: "🔒 Requires account",
  userNotice: "💡 Did you know? By creating an account you will be able to access detailed content of the volumes, mark videos as watched and have personalized tracking of your progress.",

  // Search section
  searchTitle: "Chapter Search",
  searchDescription: "Find and access any specific chapter directly using the Volume-Index format",
  searchPlaceholder: "Example: 11-5",
  searchButton: "Search Chapter",
  searching: "Searching...",
  searchFormat: "Format",
  searchFormatExample: "Volume-Index",
  searchFormatExampleDetail: "Example: 11-5 (Volume 11, Chapter 5)",
  searchRange: "Available Range",
  searchRangeDetail: "Volumes 1-36",
  searchRangeIndexes: "Indexes from 1 onwards",

  // Search errors
  searchErrorEmpty: "Please enter a valid format (e.g.: 11-5)",
  searchErrorInvalidFormat: "Invalid format. Use: Volume-Index (e.g.: 11-5)",
  searchErrorInvalidNumbers: "Enter valid numbers (e.g.: 11-5)",
  searchErrorVolumeRange: "Volume must be between 1 and 36",
  searchErrorIndexPositive: "Index must be a positive number",
  searchErrorRequiresLogin: "You must log in to access detailed content",
  searchErrorVolumeNotFound: "Volume {volume} not found",
  searchErrorNoContent: "Volume {volume} has no content available yet",
  searchErrorNavigation: "Navigation error. Please try again.",

  // Donation section
  donationTitle: "Help us develop this Book of Heaven platform",
  donationDescription: "Your support allows us to continue sharing the teachings of the Divine Will with the world",
  donateButton: "Donate here",
  donationUrl: "https://donorbox.org/divinewillapp-2",

  // Footer
  footerCopyright: "© {year} Fundación Hijos de la Luz, Inc. All rights reserved.",

  // Gospel Page strings
  gospelTitle: "Gospel of the Day",
  backToHome: "Back to Home",
  loadingGospel: "Loading gospel...",
  previousDay: "Previous day",
  nextDay: "Next day",
  previous: "← Previous",
  next: "Next →",
  share: "Share",
  copyLink: "Copy Link",
  introduction: "Introduction",
  gospel: "Gospel",
  reflection: "Gospel of the Day Reflection",
  relatedLinks: "Related links",
  additionalInfo: "Additional information",
  liturgicalNote: "Liturgical note:",
  source: "Source:",
  rights: "Rights:",
  viewOriginalSource: "View original source",
  keyboardShortcuts: "Keyboard shortcuts: ← → to navigate between days | Esc to return to home",

  // Share messages
  shareSuccess: "✅ Link copied to clipboard",
  shareError: "❌ Error copying link",
  shareTitle: "Gospel of the Day - Book of Heaven",
  shareWebTitle: "Share using the device's native menu",
  shareClipboardTitle: "Copy link to clipboard",
  shareFallbackTitle: "Copy link to share",
  defaultLinkText: "Link",

  // Admin view count
  adminViews: "Views (Admin):",
  adminViewsLoading: "Loading...",
  adminViewsCount: "views",

  // Error messages
  gospelNotAvailable: "Sorry, the gospel for the date {date} is not available at this time.",
  gospelLoadError: "Could not load the Gospel of the Day. Please try again later.",
  tryAgainLater: "Please try again later.",

  // Date formatting
  months: {
    0: "January",
    1: "February",
    2: "March",
    3: "April",
    4: "May",
    5: "June",
    6: "July",
    7: "August",
    8: "September",
    9: "October",
    10: "November",
    11: "December"
  },
  weekdays: {
    0: "Sunday",
    1: "Monday",
    2: "Tuesday",
    3: "Wednesday",
    4: "Thursday",
    5: "Friday",
    6: "Saturday"
  },

  // Login Page strings
  backToHome: "Back to home",
  administration: "Administration",
  adminAccess: "Access for administrators",
  username: "Username",
  password: "Password",
  login: "Log in",
  loggingIn: "Logging in...",
  invalidCredentials: "Invalid username or password",
  adminOnly: "Only for authorized administrators",

  // User Login Page strings
  userLogin: "Log In",
  accessYourAccount: "Access your account",
  email: "Email",
  emailOrPasswordIncorrect: "Incorrect email or password",
  forgotPassword: "Forgot your password?",
  noAccount: "Don't have an account?",
  createAccount: "Create account",
  areYouAdmin: "Are you an administrator?",

  // User Register Page strings
  createAccountTitle: "Create Account",
  joinBookOfHeaven: "Join Book of Heaven",
  firstName: "First Name",
  lastName: "Last Name",
  confirmPassword: "Confirm Password",
  creatingAccount: "Creating account...",
  passwordsDoNotMatch: "Passwords do not match",
  passwordMinLength: "Password must be at least 6 characters",
  registrationError: "Error registering user. Check that the email is not already in use.",
  alreadyHaveAccount: "Already have an account?",
  registrationSuccessful: "Registration Successful!",
  verificationEmailSent: "We have sent a verification link to",
  nextSteps: "Next steps:",
  checkInbox: "1. Check your inbox",
  clickVerificationLink: "2. Click the verification link",
  loginToAccount: "3. Log in to your account",
  accountCreatedSuccessfully: "Your account has been created successfully. We have sent a welcome email to",
  readyToStart: "You can start now!",
  accountReadyToUse: "Your account is ready to use. You can log in immediately.",
  goToLogin: "Go to Log In",
  returnToHome: "Back to Home",

  // Forgot Password Page strings
  backToLogin: "Back to login",
  forgotPasswordTitle: "Forgot your password?",
  forgotPasswordDescription: "Enter your email and we'll send you a link to reset your password",
  forgotPasswordError: "Error sending recovery request",
  developmentMode: "🔧 Development mode - Test token:",
  testReset: "Test reset",
  emailPlaceholder: "your-email@example.com",
  sending: "Sending...",
  sendRecoveryLink: "Send recovery link",
  rememberedPassword: "Remembered your password?",

  // Reset Password Page strings
  validatingToken: "Validating recovery token...",
  invalidToken: "Invalid Token",
  tokenNotProvided: "Recovery token not provided",
  invalidOrExpiredToken: "Invalid or expired recovery token",
  requestNewLink: "Request new link",
  resetPasswordTitle: "Reset Password",
  enterNewPassword: "Enter your new password",
  newPassword: "New Password",
  confirmNewPassword: "Confirm New Password",
  newPasswordPlaceholder: "Minimum 6 characters",
  confirmNewPasswordPlaceholder: "Confirm your new password",
  passwordRequirements: "Password requirements:",
  atLeast6Characters: "At least 6 characters",
  passwordsMustMatch: "Passwords must match",
  resetting: "Resetting...",
  resetPassword: "Reset password",
  passwordResetSuccess: "Password Reset!",
  passwordResetSuccessMessage: "Your password has been updated successfully. You can now log in with your new password.",
  resetPasswordError: "Error resetting password",

  // Email Verification Page strings
  emailVerification: "Email Verification",
  verifyingEmail: "Verifying your email...",
  emailVerified: "Email Verified!",
  verificationError: "Verification Error",
  noVerificationToken: "No verification token provided",
  emailVerificationError: "Error verifying email",
  enterEmailToResend: "Enter your email address to resend verification:",
  verificationEmailSent: "Verification email sent! Check your inbox.",
  errorSendingEmail: "Error sending email. Please try again.",
  resendVerificationEmail: "Resend Verification Email",

  // About Modal strings
  about: "About",
  closeModal: "Close modal",
  loading: "Loading...",
  errorLoadingAbout: "Error loading about content",
  retry: "Retry",
  fallbackContact: "## 📩 Contact\n\nDo you have questions, suggestions or want to collaborate with this mission?\n\nYou can write to us at the following email:\n\n**DivinaVoluntadApp@gmail.com**",

  // News Section strings
  memberContent: "🔒 Member content",
  publicAnnouncement: "📢 Public announcement",

  // About Page strings
  aboutPageTitle: "About",
  loadingContent: "Loading content...",
  aboutPageFooter: "© 2025 Book of Heaven - Sharing the teachings of the Divine Will",

  // Volume Page strings
  volumePageLoading: "Loading volume content...",
  volume: "Volume",
  verifyingAuth: "Verifying authentication...",
  videosAvailable: "videos available",
  videosWatched: "watched",
  videoCountFormat: "{watched} of {total} watched",
  selectVideoToPlay: "Select a video to play",
  previousButton: "Previous",
  nextButton: "Next",
  searchChapterTitle: "Search Chapter in this Volume",
  searchIndexPlaceholder: "Index (e.g.: 5)",
  searchButton: "Search",
  searchTip: "💡 <strong>Tip:</strong> Just enter the chapter number you're looking for (e.g.: 5 for chapter 5)",

  // Search errors
  searchErrorIndex: "Please enter an index number (e.g.: 5)",
  searchErrorPlaylistNotLoaded: "Playlist not loaded. Please wait a moment and try again.",
  searchErrorInvalidNumber: "Enter a valid number (e.g.: 5)",
  searchErrorNotAvailable: "Not Available",
  searchErrorChapterNotFound: "Chapter {chapter} not available in this volume",
  searchSuccessFound: "✓ Chapter {chapter} found",

  // Volume errors
  noDetailedContent: "No detailed content found for this volume",
  loginRequired: "You need to log in to view this content",
  volumeLoadError: "Error loading volume content",
  mainContentError: "Error loading main content",
  sessionExpiredRedirect: "Session expired. Redirecting to login...",
  noteLoadError: "Error loading note",

  // Donation message
  helpDevelopMessage: "🙏 Help us develop this page of the platform by making a donation here.",

  // Navigation
  goBack: "Go back",
  inicio: "Home",

  // Share functionality
  shareChapter: "Share chapter",
  whatsappInstructions: "For WhatsApp: Copy the link and also send the thumbnail image",
  linkCopied: "✓ Link copied to clipboard",
  copyError: "Could not copy automatically. Copy manually: {url}",

  // Video controls
  markAsWatched: "Mark as watched",
  markAsUnwatched: "Mark as unwatched",
  watchOnYoutube: "Watch on YouTube",

  // Content sections
  mainContent: "Main Content",
  additionalContent: "Additional Content",
  personalNotes: "Personal Notes",
  saveNote: "Save Note",

  // Temas functionality
  exploreRelatedTopics: "Explore Related Topics",

  // General UI
  index: "index",
  chapter: "chapter",
  saving: "Saving...",
  
  // Volume Page Content Labels
  Volume_Description: "Description",
  Volume_Date: "Date",
  Volume_Summary: "Summary", 
  Volume_NoteSaved: "Note saved",
  Volume_QuestionsAndAnswers: "Questions and Answers",
  Volume_WritePersonalNotes: "Write your personal notes about this chapter...",
  Volume_Characters: "characters",
  Volume_ShowAnswer: "Show answer",
  Volume_HideAnswer: "Hide answer",
  Volume_BiblicalReferences: "Biblical References",
  Volume_LookupBiblicalQuote: "Look up biblical quote", 
  Volume_SpiritualExercises: "Spiritual Exercises",
  Volume_KeyPoints: "Key Points",
  Volume_PublicComments: "Public Comments",
  Volume_PaginationFormat: "{current} of {total}",
  
  // Sharing Messages
  Volume_ShareMessage1: "📖 This chapter from the Book of Heaven 💫 touches the soul. Register and read it here:",
  Volume_ShareMessage2: "🔥 This message from Heaven transforms. Enter with your account and read:",
  Volume_ShareMessage3: "✨ It's worth it. Jesus speaks directly to the heart in this chapter. Just register:",
  
  // Forgot Password Messages
  forgotPasswordRecoveryMessage: "If the email exists in our system, you will receive a recovery link"
};